import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withReducer from '@Hooks/withReducer';
import { useHistory } from 'react-router-dom';
import ListOfFilters from './ListOfFilters';
import { listOfFiltersReducerKey } from './ListOfFiltersConstants';
import { areParamsForFiltersRequestValid } from './ListOfFiltersUtils';
import listOfFiltersReducer from './ListOfFiltersReducer';
import {
  filters as filtersSelector,
  paramsForFiltersRequest as paramsForFiltersRequestSelector,
  keyifyParamsForFiltersRequest as keyifyParamsForFiltersRequestSelector,
} from './ListOfFiltersSelectors';
import { fetchFilters as fetchFiltersAction, toggleFilter as toggleFilterAction } from './ListOfFiltersActions';

export function ListOfFiltersContainer(props) {
  const history = useHistory();
  const { filters, paramsForFiltersRequest, keyifyParamsForFiltersRequest, dependenciesForLoadFiltersDone, fetchFilters } = props;
  const loadFilters = () => {
    if (filters) {
      return;
    }

    if (!areParamsForFiltersRequestValid(paramsForFiltersRequest)) {
      return;
    }

    fetchFilters(paramsForFiltersRequest, keyifyParamsForFiltersRequest);
  };

  useEffect(() => {
    if (dependenciesForLoadFiltersDone) {
      loadFilters();
    }
  }, [dependenciesForLoadFiltersDone, history.location.state]);

  return <ListOfFilters {...props} />;
}

ListOfFiltersContainer.propTypes = {
  filters: PropTypes.instanceOf(List),
  paramsForFiltersRequest: PropTypes.object,
  keyifyParamsForFiltersRequest: PropTypes.string,
  dependenciesForLoadFiltersDone: PropTypes.bool,
  fetchFilters: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    filters: filtersSelector(state),
    paramsForFiltersRequest: paramsForFiltersRequestSelector(state),
    keyifyParamsForFiltersRequest: keyifyParamsForFiltersRequestSelector(state),
  };
}

const mapDispatchToProps = {
  fetchFilters: fetchFiltersAction,
  toggleFilter: toggleFilterAction,
};

export default compose(
  withReducer(listOfFiltersReducerKey, listOfFiltersReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(ListOfFiltersContainer);
